import type { ComponentType, JSX } from 'react';
import { useContext } from 'react';
import { ProtectorConfigProviderContext } from './config-provider/config-provider';

const PROVIDER_ERROR_PREFIX = '[new-ui] Components from @protector/new-ui must be wrapped with ConfigProvider from @protector/new-ui.';

function createProviderError(componentName: string) {
  return new Error(
    `${PROVIDER_ERROR_PREFIX} Missing provider for ${componentName}. Example: <ConfigProvider><${componentName} /></ConfigProvider>.`
  );
}

export function useEnsureConfigProvider(componentName: string) {
  const hasProvider = useContext(ProtectorConfigProviderContext);

  if (!hasProvider) {
    throw createProviderError(componentName);
  }
}

export function withConfigProviderGuard<Props extends object>(Component: ComponentType<Props>, componentName: string) {
  function GuardedComponent(props: Props): JSX.Element {
    useEnsureConfigProvider(componentName);
    return <Component {...props} />;
  }

  GuardedComponent.displayName = `WithConfigProviderGuard(${Component.displayName ?? Component.name ?? componentName})`;

  return GuardedComponent;
}
